import { END_POINTS } from "../constants/url";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  statusCode: number;
  message: string;
}

export const categoriesApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    addCategory: builder.mutation<
      CommonResponseType,
      {
        categoryType: string;
        name: string;
        parentId?: string;
      }
    >({
      query: (body) => ({
        url: END_POINTS.category,
        method: "POST",
        body,
      }),
    }),
    getCategory: builder.query<
      CommonResponseType & {
        data: {
          data: any[];
          total: number;
        };
      },
      {
        page: number;
        limit: number;
        search: string;
        categoryType?: string;
        parentId?: string;
      }
    >({
      query: ({ page, limit, search, categoryType, parentId }) => ({
        url:
          `${END_POINTS.category}?from=${page}&size=${limit}` +
          (search?.length ? `&search=${search}` : "") +
          (parentId?.length ? `&parentId=${parentId}` : "") +
          (categoryType?.length ? `&type=${categoryType}` : ""),
        method: "GET",
      }),
    }),
    getCategoryDetail: builder.query<
      CommonResponseType & {
        data: { categoryName: string };
      },
      {
        id: string;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.category}/${id}`,
        method: "GET",
      }),
    }),
    updateCategory: builder.mutation<
      CommonResponseType & { data: any },
      { body: { isBlocked?: boolean; categoryName?: string }; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.category}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    deleteCategory: builder.mutation<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.category}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetCategoryQuery,
  useAddCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
  useLazyGetCategoryDetailQuery,
} = categoriesApi;
